import * as ko from "knockout";
import PromiseRequest from "../../../req/PromiseRequest";
import {IMessage, IMessageData, IRouteDefinitionParams, IRuleset} from "../../../index";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {createErrorMessage, validateEmail} from "../../../util/misc";
import {global} from "../../../appContext";
import {RequestRouteData} from "../../../req/RequestRouteData";
import {nsMessages} from "../fn";
import {ObjectTypeId} from "../../../constants";
import {nsFa} from "../../fa/fn";
import {nsRoute} from "../../../util/route";
import IsType = nsMessages.TypeChecker;
import getAddRecipientLabel = nsMessages.getAddRecipientLabel;
import i = nsFa.i;
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import infoHtml from './info.html?raw';

export let template = infoHtml;

export class viewModel extends ParsedRouteDataDecorator{
    private pv = global.permissionValidator;
    private data!: IMessage;
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private readonly req: PromiseRequest = global.getPromiseRequest('getobject');
    private readonly requestRouteData!: RequestRouteData;
    private reqRuleset = global.getPromiseRequest('getruleset');
    private isType: any;
    private objectTypeId!: ObjectTypeId;
    private showSend!: boolean;
    private splitRecipients = nsMessages.splitRecipients

    constructor(params: IRouteDefinitionParams) {
        super(params)
        this.init();
    }

    private init() {
        this.isReady(false);
        this.__requestRouteData!.request()
            .then((data: any[]) => {
                this.data = data[0] as IMessage;
                const isType = new IsType(this.data.messagetype);
                this.isType = isType.isType.bind(isType);
                if (this.data.rulesetid) {
                    return this.reqRuleset.request({id: this.data.rulesetid})
                }
            })
            .then((data: IRuleset[]) => {
                this.objectTypeId = data?.[0]?.objecttype?.id ?? ObjectTypeId.User;
                this.showSend = this.objectTypeId == ObjectTypeId.User;
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))));
    }

    private addRecipientLabel(): string {
        return getAddRecipientLabel(this.data.messagetypeid);
    }

    private getRecipient(recipient: string): string {
        if (this.isType('message')) {
            return recipient;
        }
        let icon = '';
        let protocol = '';
        if (this.isType('sms')) {
            icon = 'fa-phone';
            protocol = 'tel';
        } else if (this.isType('email')) {
            if (validateEmail(recipient)) {
                icon = 'fa-envelope';
                protocol = 'mailto';
            } else {
                return `${i('fa-pencil-ruler')}<span class="dynamic-expression">${recipient}</span>`;
            }
        }
        return `${i(icon)} <a href="${protocol}:${recipient}">${recipient}</a>`;
    }


    override dispose() {
        this.kosub.unsuscribeAll();
        this.req.abort();
    }
}
